import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@a/img/programme/banner.png'


_pushScopeId("data-v-4af6eb9f")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "company-exhibit exhibit" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["innerHTML"]
_popScopeId()

import PageContainer from "@c/PageContainer.vue";
import { ref, computed, Ref } from "vue";
import Breadcrumb from "@c/ui/Breadcrumb.vue";
import programme from "@config/programmeConfig";
import { getParams } from "@/utils/tools";
import { number } from "echarts/core";

export default _defineComponent({
  setup(__props) {

const params = getParams();
const programmeObj = programme.filter((item) => {
  return item.id === Number(params.id);
})[0];
let barList: Ref<
  {
    title: string;
    url: string;
  }[]
> = ref([
  { title: "解决方案", url: "programme.html" },
  { title: params.name, url: "#" },
]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageContainer, {
    navActive: 3,
    id: "company"
  }, {
    exhibition: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(Breadcrumb, { barList: _unref(barList) }, null, 8, ["barList"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(programmeObj).title), 1),
        _createElementVNode("div", {
          innerHTML: _unref(programmeObj).html
        }, null, 8, _hoisted_4)
      ])
    ]),
    _: 1
  }))
}
}

})